//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  import { CollectionModel } from './CollectionModel';
  
  export class ModuleModel extends ModelBase {
      static readonly $typeName = 'ModuleModel';
      public moduleName: string;
      public ruleCollections: CollectionModel[];
      
  }



// WEBPACK FOOTER //
// ./src/app/businessRule/models/ModuleModel.ts